import Alpine from "alpinejs";

export function Alpinejs() {
  window.Alpine = Alpine;
  queueMicrotask(() => {
    Alpine.start();
  });
}
